// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

/// <summary>
/// Базовый класс для серии данных
/// </summary>
export abstract class TerceraChartBaseSeries {
/// <summary>
/// Получить значение указанного объекта
/// </summary>
public abstract GetValue (index, level, cashItemIndex): number;

/// <summary>
/// Количество объектов
/// </summary>
public abstract Count (): number;

public Length (): number {
    return 0;
}

public abstract Dispose (): void;
}
